import {
    postData,
    destroyData,
    getDataCache,
    getDataWithParams
} from '@/store/config/method'
const initialState = () => ({
    item: [],
    list: [],
    request: [],
    msg: 'Jaringan Bermasalah',
    status: 0,
})
const state = initialState
const getters = {
    getItem: state => (type) => state.item[type],
    getList: state => (type) => state.list[type] || {last_page: 0, data: [], total: 0},
    getRequest: state => (type) => state.request[type] || {
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null,
    },
    getMsg: state => state.msg,
    getStatus: state => state.status,
}

const actions = {
    async fetchData({
        commit
    }, {url, type, params = {}}) {
        try {
            var response = await getDataCache(`/${url}`, params);
            commit('SET_ITEM', {response: response.data, type: type});
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getListData({
        commit, state
    }, {url, type, request}) {
        try {
            state.request[type] = request
            var response = await getDataWithParams(`/${url}`,request);
            commit('SET_LIST', {response: response.data, type: type});
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submit({
        commit, state
    }, {url, data, type}) {
        try {
            var response = await postData(`/${url}`,data);
            state.request[type] = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', {response: response.data, type: type});
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async destroy({
        commit, rootState, state
    }, url) {
        try {
            var response = await destroyData(`/${url}`);
            const type = rootState.deleteConfirmation.variable
            state.request[type] = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', {response: response.data, type: type});
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error?.status == 400){
            state.msg = error?.data.msg
            state.status = error?.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_ITEM(state, {response, type}) {
        state.msg = response.msg
        state.status = response.status
        state.item[type] = response.data
    },
    SET_LIST(state, {response, type}) {
        state.msg = response.msg
        state.status = response.status
        state.list[type] = response.data
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}